import type { AdditionalAnalyticAttributes } from '@atlassian/conversation-assistant-message-actions-api/types';
import type { ConversationResultAttributionContext } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import type { MessageSource } from './types';

type ApplyResultAttributionContextParams = {
	resultAttributionContext?: ConversationResultAttributionContext;
	routingAgentId: string;
	messageSources?: Partial<MessageSource>;
	additionalAnalyticAttributes?: AdditionalAnalyticAttributes;
};

type ResultAttributionAnalytics = {
	messageSources?: Partial<MessageSource>;
	additionalAnalyticAttributes?: AdditionalAnalyticAttributes;
	shouldClearResultAttributionContext?: boolean;
};

export const applyResultAttributionContext = ({
	resultAttributionContext,
	routingAgentId,
	messageSources,
	additionalAnalyticAttributes,
}: ApplyResultAttributionContextParams): ResultAttributionAnalytics => {
	const sourceAgentId = resultAttributionContext?.sourceAgentId;
	const launchSource = resultAttributionContext?.launchSource;

	if (resultAttributionContext === undefined || launchSource === undefined) {
		return { messageSources, additionalAnalyticAttributes };
	}

	if (sourceAgentId !== undefined && sourceAgentId !== routingAgentId) {
		return {
			messageSources,
			additionalAnalyticAttributes,
			shouldClearResultAttributionContext: true,
		};
	}

	const attributedMessageSources = messageSources?.followUpSource
		? messageSources
		: {
				...(messageSources ?? {}),
				followUpSource: launchSource,
			};
	const attributedAdditionalAnalyticAttributes = {
		launchSource,
		...(additionalAnalyticAttributes ?? {}),
	};

	return {
		messageSources: attributedMessageSources,
		additionalAnalyticAttributes: attributedAdditionalAnalyticAttributes,
	};
};
